export default "__VITE_PUBLIC_ASSET__fb2be44c__"